interface PageHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <div className={action ? 'flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between' : ''}>
      <div>
        <h1 className="text-2xl font-bold text-brand-neutral-900">{title}</h1>
        {description && <p className="mt-1 text-sm text-brand-neutral-600">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
